import { connect } from 'react-redux'
import ApplicationOffers from 'components/ApplicationOffers/ApplicationOffers'
import {
    getApplicationOffersList
} from 'actions/applicationOffers'

function mapStateToProps(stateProps) {
    return {
        applicationOffersList: stateProps.applicationOffers?.applicationOffersList || [],
        totalRecords: stateProps.applicationOffers?.totalRecords || 0,
        totalPages: stateProps.applicationOffers?.totalPages || 0
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    }
}

export default connect(
    mapStateToProps,
    {
        getApplicationOffersList // Action to get the application offers list
    },
    mergeProps
)(ApplicationOffers)